export function getImageSources(sources) {
  return {
    srcSet: `
      ${sources.small} 750w,
      ${sources.medium} 1280w,
      ${sources.large} 1920w
    `,
    src: sources.large,
  };
}

export const images = {
  exampleEpic1: getImageSources({
    small: require("/images/_example/epic-1-1920.jpg?max-width=750"),
    medium: require("/images/_example/epic-1-1920.jpg?max-width=1280"),
    large: require("/images/_example/epic-1-1920.jpg"),
  }),
  exampleEpic2: getImageSources({
    small: require("/images/_example/epic-2-1920.jpg?max-width=750"),
    medium: require("/images/_example/epic-2-1920.jpg?max-width=1280"),
    large: require("/images/_example/epic-2-1920.jpg"),
  }),
  exampleEpic3: getImageSources({
    small: require("/images/_example/epic-3-1920.jpg?max-width=750"),
    medium: require("/images/_example/epic-3-1920.jpg?max-width=1280"),
    large: require("/images/_example/epic-3-1920.jpg"),
  }),
  exampleEpic4: getImageSources({
    small: require("/images/_example/epic-4-1920.jpg?max-width=750"),
    medium: require("/images/_example/epic-4-1920.jpg?max-width=1280"),
    large: require("/images/_example/epic-4-1920.jpg"),
  }),
  exampleEpic5: getImageSources({
    small: require("/images/_example/epic-5-1920.jpg?max-width=750"),
    medium: require("/images/_example/epic-5-1920.jpg?max-width=1280"),
    large: require("/images/_example/epic-5-1920.jpg"),
  }),
  introVideoStill: getImageSources({
    small: require("/images/home/intro-video-still.jpg?max-width=1280") /* we use a higher max-width than usual here because of the cropping on mobile and displaying a sharp image on Retina displays */,
    medium: require("/images/home/intro-video-still.jpg?max-width=1280"),
    large: require("/images/home/intro-video-still.jpg"),
  }),
  performanceHeader: getImageSources({
    small: require("/images/home/performance-header.jpg?max-width=1280") /* we use a higher max-width than usual here because of the cropping on mobile and displaying a sharp image on Retina displays */,
    medium: require("/images/home/performance-header.jpg?max-width=1280"),
    large: require("/images/home/performance-header.jpg"),
  }),
  performanceSlider1: getImageSources({
    small: require("/images/home/performance-slider-1-750.jpg"),
    medium: require("/images/home/performance-slider-1-1280.jpg"),
    large: require("/images/home/performance-slider-1.jpg"),
  }),
  performanceSlider2: getImageSources({
    small: require("/images/home/performance-slider-2-750.jpg"),
    medium: require("/images/home/performance-slider-2-1280.jpg"),
    large: require("/images/home/performance-slider-2.jpg"),
  }),
  performanceSlider3: getImageSources({
    small: require("/images/home/performance-slider-3-750.jpg"),
    medium: require("/images/home/performance-slider-3-1280.jpg"),
    large: require("/images/home/performance-slider-3.jpg"),
  }),
  performanceSlider4: getImageSources({
    small: require("/images/home/performance-slider-4-750.jpg"),
    medium: require("/images/home/performance-slider-4-1280.jpg"),
    large: require("/images/home/performance-slider-4.jpg"),
  }),
  performanceSlider5: getImageSources({
    small: require("/images/home/performance-slider-5-750.jpg"),
    medium: require("/images/home/performance-slider-5-1280.jpg"),
    large: require("/images/home/performance-slider-5.jpg"),
  }),
  performanceSlider6: getImageSources({
    small: require("/images/home/performance-slider-6-750.jpg"),
    medium: require("/images/home/performance-slider-6-1280.jpg"),
    large: require("/images/home/performance-slider-6.jpg"),
  }),
  performanceCeilingImg: getImageSources({
    small: require("/images/home/performance-ceiling.jpg?max-width=750"),
    medium: require("/images/home/performance-ceiling.jpg?max-width=1280"),
    large: require("/images/home/performance-ceiling.jpg"),
  }),
  performanceExplore: getImageSources({
    small: require("/images/home/performance-explore.jpg?max-width=750"),
    medium: require("/images/home/performance-explore.jpg?max-width=1280"),
    large: require("/images/home/performance-explore.jpg"),
  }),
  designInDepth: getImageSources({
    small: require("/images/home/design-indepth-length-2.jpg?max-width=750"),
    medium: require("/images/home/design-indepth-length-2.jpg?max-width=1280"),
    large: require("/images/home/design-indepth-length-2.jpg"),
  }),
  designCabinSlider1: getImageSources({
    small: require("/images/home/design-cabin-1.jpg?max-width=750"),
    medium: require("/images/home/design-cabin-1.jpg?max-width=1280"),
    large: require("/images/home/design-cabin-1.jpg"),
  }),
  designAirframeIntroSlider0: getImageSources({
    small: require("/images/home/design-airframe-intro-0.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-intro-0.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-intro-0.jpg"),
  }),
  designAirframeIntroSlider1: getImageSources({
    small: require("/images/home/design-airframe-intro-1.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-intro-1.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-intro-1.jpg"),
  }),
  designAirframeIntroSlider2: getImageSources({
    small: require("/images/home/design-airframe-intro-2.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-intro-2.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-intro-2.jpg"),
  }),
  designAirframeIntroSlider3: getImageSources({
    small: require("/images/home/design-airframe-intro-3.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-intro-3.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-intro-3.jpg"),
  }),
  designAirframeIntroSlider4: getImageSources({
    small: require("/images/home/design-airframe-intro-4.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-intro-4.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-intro-4.jpg"),
  }),
  designAirframeIntroSlider5: getImageSources({
    small: require("/images/home/design-airframe-intro-5.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-intro-5.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-intro-5.jpg"),
  }),
  designAirframeIntroSlider6: getImageSources({
    small: require("/images/home/design-airframe-intro-6.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-intro-6.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-intro-6.jpg"),
  }),
  designAirframeIntroSlider7: getImageSources({
    small: require("/images/home/design-airframe-intro-7.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-intro-7.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-intro-7.jpg"),
  }),
  designAirframeIntroSlider8: getImageSources({
    small: require("/images/home/design-airframe-intro-8.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-intro-8.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-intro-8.jpg"),
  }),
  designAirframeSlider1: getImageSources({
    small: require("/images/home/design-airframe-1.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-1.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-1.jpg"),
  }),
  designAirframeSlider2: getImageSources({
    small: require("/images/home/design-airframe-2.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-2.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-2.jpg"),
  }),
  designAirframeSlider3: getImageSources({
    small: require("/images/home/design-airframe-3.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-3.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-3.jpg"),
  }),
  designAirframeSlider4: getImageSources({
    small: require("/images/home/design-airframe-4.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-4.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-4.jpg"),
  }),
  designAirframeSlider5: getImageSources({
    small: require("/images/home/design-airframe-5.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-5.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-5.jpg"),
  }),
  designAirframeSlider6: getImageSources({
    small: require("/images/home/design-airframe-6.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-6.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-6.jpg"),
  }),
  designAirframeSlider7: getImageSources({
    small: require("/images/home/design-airframe-7.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-7.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-7.jpg"),
  }),
  contactBackground: getImageSources({
    small: require("/images/home/contact-background-768.jpg?max-width=750"),
    medium: require("/images/home/contact-background-1280.jpg?max-width=1280"),
    large: require("/images/home/contact-background-2560.jpg"),
  }),
  e1000Render: getImageSources({
    small: require("/images/_example/e1000.png?max-width=750"),
    medium: require("/images/_example/e1000.png?max-width=1280"),
    large: require("/images/_example/e1000.png"),
  }),
  designHeader: getImageSources({
    small: require("/images/home/design-header.jpg?max-width=750"),
    medium: require("/images/home/design-header.jpg?max-width=1280"),
    large: require("/images/home/design-header.jpg"),
  }),
  designAirframeIntro: getImageSources({
    small: require("/images/home/design-airframe-intro.jpg?max-width=750"),
    medium: require("/images/home/design-airframe-intro.jpg?max-width=1280"),
    large: require("/images/home/design-airframe-intro.jpg"),
  }),
  designFlightDeck: getImageSources({
    small: require("/images/home/design-flightdeck.jpg?max-width=750"),
    medium: require("/images/home/design-flightdeck.jpg?max-width=1280"),
    large: require("/images/home/design-flightdeck.jpg"),
  }),
  designCabin: getImageSources({
    small: require("/images/home/design-cabin.jpg?max-width=750"),
    medium: require("/images/home/design-cabin.jpg?max-width=1280"),
    large: require("/images/home/design-cabin.jpg"),
  }),
  designCabinBottom: getImageSources({
    small: require("/images/home/design-cabin-bottom.jpg"),
    medium: require("/images/home/design-cabin-bottom.jpg"),
    large: require("/images/home/design-cabin-bottom.jpg"),
  }),
  introVideo: getImageSources({
    small: require("/images/_example/intro-brand-video.jpg?max-width=750"),
    medium: require("/images/_example/intro-brand-video.jpg?max-width=1280"),
    large: require("/images/_example/intro-brand-video.jpg"),
  }),
};

export const videos = {
  sample1: {
    src: require("/video/_example/sample-1.mp4"),
    thumbnail: require("/video/_example/sample-1.png"),
  },
  demo: {
    src: require("/video/_example/demo.mp4"),
    thumbnail: null,
  },
  intro: {
    src: require("/video/_demo/intro.mp4"),
    thumbnail: null,
  },
};

export const vimeoCdnVideos = {
  intro: {
    960: "https://player.vimeo.com/progressive_redirect/playback/767319067/rendition/720p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=16d0be502fe25d1f37f199230434f30c28725d375022f639066a22761ac7a208",
    1280: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
    1920: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
  },
  introLong: {
    960: "https://player.vimeo.com/progressive_redirect/playback/767319067/rendition/720p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=16d0be502fe25d1f37f199230434f30c28725d375022f639066a22761ac7a208",
    1280: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
    1920: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
  },
  brand: {
    960: "https://player.vimeo.com/progressive_redirect/playback/767319067/rendition/720p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=16d0be502fe25d1f37f199230434f30c28725d375022f639066a22761ac7a208",
    1280: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
    1920: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
  },
  brandWithoutAudio: {
    960: "https://player.vimeo.com/progressive_redirect/playback/767319067/rendition/720p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=16d0be502fe25d1f37f199230434f30c28725d375022f639066a22761ac7a208",
    1280: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
    1920: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
  },
  product: {
    960: "https://player.vimeo.com/progressive_redirect/playback/767319067/rendition/720p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=16d0be502fe25d1f37f199230434f30c28725d375022f639066a22761ac7a208",
    1280: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
    1920: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
  },
  performanceCeiling: {
    960: "https://player.vimeo.com/progressive_redirect/playback/767319067/rendition/720p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=16d0be502fe25d1f37f199230434f30c28725d375022f639066a22761ac7a208",
    1280: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
    1920: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
  },
  designHeaderLoop: {
    960: "https://player.vimeo.com/progressive_redirect/playback/767319067/rendition/720p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=16d0be502fe25d1f37f199230434f30c28725d375022f639066a22761ac7a208",
    1280: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
    1920: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
  },
  designAirframe: {
    960: "https://player.vimeo.com/progressive_redirect/playback/767319067/rendition/720p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=16d0be502fe25d1f37f199230434f30c28725d375022f639066a22761ac7a208",
    1280: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
    1920: "https://player.vimeo.com/progressive_redirect/playback/764230127/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=f43146f5ff162fca5b0ee01afbabb3ff1cd3dc3da097e1f8e38af669e74e30d7",
  },
  aboutE1000GX: {
    960: "/wp-content/uploads/2022/02/EPIC-AIRCRAFT_E1000GX_WEB.mp4",
    1280: "/wp-content/uploads/2022/02/EPIC-AIRCRAFT_E1000GX_WEB.mp4",
    1920: "/wp-content/uploads/2022/02/EPIC-AIRCRAFT_E1000GX_WEB.mp4",
  },
  whyFlyVimeo: {
    960: "https://player.vimeo.com/progressive_redirect/playback/755658629/rendition/540p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=faffb74c1e3c5753e67d4ec1bfdb230dfa9e6a6178b36bb6b0f0154fc6c0752e",
    1280: "https://player.vimeo.com/progressive_redirect/playback/755658629/rendition/720p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=d1d111cc576293c470851a714eed9ed24d9a9c73987d37cb479df93e1f40fb17",
    1920: "https://player.vimeo.com/progressive_redirect/playback/755658629/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1647439596&signature=2b05ddbec464369b7fa36ad9a10d60f9ac9b433e98405beb2b2f04f6628c896a",
  },
};
